module.exports = __webpack_public_path__ + "static/Henriqueta-cf469b7bdc2cf829c388bf235023123e.jpeg";